import classNames from "classnames";
import { useTranslation } from "react-i18next";
import LogoTrophy from "../../assets/logo-trophy.svg?react";

interface ILoaderProps {
  message?: string;
  className?: string;
}

export const Loader = ({
  message,
  className = "text-primary",
}: ILoaderProps) => {
  const [t] = useTranslation();

  return (
    <div
      className={classNames(
        "flex h-full w-full flex-col items-center justify-center py-10 text-primary-500 dark:text-primary-100",
        className
      )}
    >
      <div className="relative mb-5 flex h-22 w-22 items-center justify-center overflow-hidden rounded-3xl border border-white/35 bg-white/35 shadow-[0_20px_55px_-35px_rgba(15,23,42,0.75)] backdrop-blur-2xl dark:border-primary-800/45 dark:bg-content-900/35">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(125%_90%_at_12%_0%,rgba(255,255,255,0.75)_0%,rgba(255,255,255,0.24)_44%,rgba(255,255,255,0.06)_100%)]" />
        <div className="pointer-events-none absolute -right-6 -top-6 h-14 w-14 rounded-full bg-accent-300/35 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-8 -left-7 h-16 w-16 rounded-full bg-primary-300/30 blur-2xl dark:bg-primary-500/15" />

        <div className="relative flex items-center justify-center">
          <span className="icon-[ph--circle-notch] h-12 w-12 animate-spin text-primary-500 dark:text-primary-200" />
          <LogoTrophy className="absolute h-5.5 w-5.5" aria-hidden="true" />
        </div>
      </div>
      <div className="font-header text-center text-xl font-medium text-content-800 dark:text-content-100">
        {message || t("global:shared.Loader.message", "Loading...")}
      </div>
    </div>
  );
};
